import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { usePermissions } from './usePermissions';

const ProtectedRoute = ({ permission, redirectTo = '/unauthorized', children }) => {
  const { getPermission } = usePermissions();
  const result = getPermission(permission);

  if (!result) {
    console.warn(`Clé de permission inconnue : ${permission}`);
    return <Navigate to={redirectTo} />;
  }

  if (!result.allowed) {
    return <Navigate to={redirectTo} />;
  }

  // Si des enfants sont fournis (cas usage simple)
  if (children) return children;

  // Sinon on assume que c’est une route parente => on rend les routes enfants
  return <Outlet />;
};

export default ProtectedRoute;